export function SET_TRANSFER_DATA(payload) {
  return {
    type: 'SET_TRANSFER_DATA',
		payload: payload
  };
}